//@flow
import { branch, renderComponent } from 'recompose'
import Error from '../ui/views/error'

export default function withErrorIfProps(propsPredicate: Function) {
  return branch(propsPredicate, renderComponent(Error))
}



// WEBPACK FOOTER //
// ./src/core/withErrorIfProps.js